import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initial',
  standalone: true
})
export class InitialPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Prende la prima lettera e aggiunge il punto
    const initial = value.charAt(0).toUpperCase();
    return `${initial}.`;
  }
}
